<!-- <div class="layout-footer">
    <img [src]="'assets/images/layout/footer-' + (layoutService.config().colorScheme === 'light' ? 'worksheet' : 'worksheet-dark') + '.svg'"
        alt="worksheet-footer-logo">
    <div class="flex gap-2">

        <label class="mt-3">Version - 1.0</label>
        <button pButton pRipple type="button" icon="pi pi-github"
            class="p-button-rounded p-button-text p-button-plain"></button>
        <button pButton pRipple type="button" icon="pi pi-facebook"
            class="p-button-rounded p-button-text p-button-plain"></button>
        <button pButton pRipple type="button" icon="pi pi-twitter"
            class="p-button-rounded p-button-text p-button-plain"></button>


    </div>
</div> -->
<div class="layout-footer">
    <img 
        [src]="'assets/images/layout/footer-' + (layoutService.config().colorScheme === 'light' ? 'worksheet' : 'worksheet-dark') + '.svg'" 
        alt="worksheet-footer-logo">
        <div class="text-center">
            <label class=" text-center text-400">Powered by Worksheet {{ getpbw()}} | version {{translate_service.getText('version')}}</label>
            <!-- <label class="mt-3 ml-2 text-center text-600">Version - 1.0</label> -->
        </div>
    <div class="flex gap-2">
      
      
        <button 
            pButton 
            pRipple 
            type="button" 
            icon="pi pi-github" 
            class="p-button-rounded p-button-text p-button-plain">
        </button>
        <button 
            pButton 
            pRipple 
            type="button" 
            icon="pi pi-facebook" 
            class="p-button-rounded p-button-text p-button-plain">
        </button>
        <button 
            pButton 
            pRipple 
            type="button" 
            icon="pi pi-twitter" 
            class="p-button-rounded p-button-text p-button-plain">
        </button>
    </div>
</div>
